

import { mapState } from 'vuex'

export default {

  computed: {
    ...mapState('general', ['snackbarText', 'centered', 'timeout', 'snackbarColor', 'isSnackbarVertical']),
    snackbar: {
      get () {
        return this.$store.state.general.snackbar
      },
      set (value) {
        this.$store.commit('general/setSnackbar', value)
      }
    }

  }

}
